import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgramariViewComponent } from './programari-view.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ViewExpansionPanelComponent } from './view-expansion-panel/view-expansion-panel.component';
import { AppointmentComponent } from './view-expansion-panel/appointment/appointment.component';

@NgModule({
    declarations: [
        ProgramariViewComponent,
        ViewExpansionPanelComponent,
        AppointmentComponent,
    ],
    imports: [
        CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    exports: [ProgramariViewComponent],
})
export class ProgramariViewModule { }
